
<poppins-dropdown
  :id="id"
  :labelName="labelName"
  :options="options"
  :value="dropdownValue"
  :status="status"
  :helperText="helperText"
  :required="required"
  :disabled="disabled"
  class="dropdown-icon-overridden"
  name="timePickerDropdown"
  @input="dropdownSelectionChanged"
>
  <icon-time class="dropdown-icon" />
</poppins-dropdown>
